import styled from 'styled-components'
import { SpaceProps, space } from 'styled-system'

import { filterSpaceProps } from '@/helpers/styled-props'

export const InfoTooltipWrapper = styled.div.withConfig({
  shouldForwardProp: filterSpaceProps(),
})<SpaceProps>`
  cursor: pointer;
  width: 14px;
  height: 14px;

  svg > path {
    fill: ${({ theme }) => theme.colors.grey};
  }

  &:hover {
    svg > path {
      fill: ${({ theme }) => theme.colors.violet};
    }
  }

  ${space}
`
